import { Component, Input, OnInit, inject } from '@angular/core';
import {VentilationFinanciere} from '../../../interface/api/VentilationFinanciere';
import {LocalStorage} from 'ngx-webstorage';
import {ToolsService} from '../../services/tools/tools.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {TranslationService} from '../../services/translation.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {AideFraisType} from "../../../interface/api/AideFraisType";

@Component({
    selector: 'app-modification-budgetaire-detail',
    templateUrl: './modification-budgetaire-detail.component.html',
    styleUrls: ['./modification-budgetaire-detail.component.scss'],
    imports: [MatIcon, DecimalPipe, DatePipe, TranslateModule],
    standalone: true,
})
export class ModificationBudgetaireDetailComponent implements OnInit {
    toolService = inject(ToolsService);
    translateService = inject(TranslateService);
    translationService = inject(TranslationService);
    private hydraService = inject(HydraService);


    @Input() modificationBudgetaire: VentilationFinanciere;

    @LocalStorage() public dateShort; // FR de base

    typesFrais: AideFraisType[];
    total: number;
    previousVersion?: VentilationFinanciere;

    montants?: Map<string, number>;
    previousVersionMontants?: Map<string, number>;


    ngOnInit(): void {
        const modificationBudgetaire = this.modificationBudgetaire;
        if (!modificationBudgetaire) {
            throw new Error('modificationBudgetaire is mandatory');
        }

        this.loadTypesFrais();
        this.loadPreviousVersion();

        this.total = this.modificationBudgetaire.ventilationFinanciereLines.reduce(
            (acc, line) => acc + line.montant,
            0
        ) + this.modificationBudgetaire.montantAdditionnel;
        this.montants = this.indexMontants(this.modificationBudgetaire);
    }

    private loadTypesFrais() {
        this.hydraService.getList(api.aideFraisTypes).subscribe(
            (res) => {
                this.typesFrais = res.getMember();
            }
        );
    }

    private loadPreviousVersion() {
        const modificationBudgetaire = this.modificationBudgetaire;
        if (!modificationBudgetaire) {
            throw new Error('modificationBudgetaire is mandatory');
        }

        if (!modificationBudgetaire.previousVersion) {
            return;
        }

        this.hydraService.getItem(HydraService.extractIRI(modificationBudgetaire.previousVersion))
            .subscribe(
                (res) => {
                    this.previousVersion = res as VentilationFinanciere;
                    this.previousVersionMontants = this.indexMontants(res as VentilationFinanciere);
                }
            );
    }

    private indexMontants(modificationBudgetaire: VentilationFinanciere) {
        return modificationBudgetaire.ventilationFinanciereLines
            .reduce(
                (acc, line) => {
                    acc.set(line.fraisType as string, line.montant);
                    return acc;
                },
                new Map<string, number>()
            );
    }

    existsLineForTypeFrais(typeFrais: AideFraisType) {
        return this.montants?.get(typeFrais['@id']) !== undefined
            || this.previousVersionMontants?.get(typeFrais['@id']) !== undefined
    }
}
